var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBeer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Beer_svg__b{fill:none;stroke:#304393;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Beer_svg__b",
    d: "M14.694 20.063l-.694-11A1 1 0 0115 8h5.5a1 1 0 011 1.063l-.694 11a1 1 0 01-1 .937h-4.114a1 1 0 01-1-.937zM8.583 4.864l.166-.332a1.059 1.059 0 000-.947A1.061 1.061 0 007.8 3H5.669a1.059 1.059 0 00-.947.585 1.059 1.059 0 000 .947l.166.332a1.2 1.2 0 01.127.537v.985A5.292 5.292 0 013.93 9.6l-.344.451A5.29 5.29 0 002.5 13.26v5.623A2.117 2.117 0 004.618 21h4.235a2.118 2.118 0 002.118-2.118V13.26a5.292 5.292 0 00-1.085-3.211L9.541 9.6a5.294 5.294 0 01-1.085-3.214V5.4a1.2 1.2 0 01.127-.536zM5.01 5.49h3.45M10.97 17H2.51M10.97 13H2.51"
  })));
}

export default SvgBeer;


//////////////////
// WEBPACK FOOTER
// ./src/icons/Beer.svg
// module id = 867
// module chunks = 101